module.exports = __webpack_public_path__ + "static/img/wolf-explore--1110.30c6d48.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/explore/wolf-explore--1110.jpg
// module id = VmZH
// module chunks = 0